import type { DashboardTheme, DashboardWidgetStyle } from './types';

const TITLE_FONT: Record<NonNullable<DashboardWidgetStyle['titleFontSize']>, string> = {
  small: '0.7rem',
  medium: '0.75rem',
  large: '0.85rem',
};

export function cardStyleFromWidget(style?: DashboardWidgetStyle, theme?: DashboardTheme): Record<string, unknown> {
  const sx: Record<string, unknown> = {};
  const bg = style?.cardBackground || theme?.widgetBackground;
  if (bg) sx.bgcolor = bg;
  const border = style?.cardBorderColor || theme?.widgetBorderColor;
  if (border) {
    sx.borderColor = border;
    sx.borderWidth = 1;
    sx.borderStyle = 'solid';
  }
  const radius = style?.cardBorderRadius ?? theme?.widgetBorderRadius;
  if (radius != null) sx.borderRadius = radius;
  const opacity = style?.cardOpacity ?? theme?.widgetOpacity;
  if (opacity != null) sx.opacity = opacity;
  return sx;
}

export function titleStyleFromWidget(style?: DashboardWidgetStyle, theme?: DashboardTheme): Record<string, unknown> {
  const sx: Record<string, unknown> = {};
  const color = style?.titleColor || theme?.titleColor;
  if (color) sx.color = color;
  if (style?.titleFontSize) sx.fontSize = TITLE_FONT[style.titleFontSize];
  return sx;
}

export function contentStyleFromWidget(style?: DashboardWidgetStyle, theme?: DashboardTheme): Record<string, unknown> {
  const color = style?.contentTextColor || theme?.contentTextColor;
  if (!color) return {};
  return { color };
}
